export enum UserActionTypeTaskPerformed {
  CanceledTask = 'CanceledTask',
  CanceledTasks = 'CanceledTasks',
  PausedTask = 'PausedTask'
}
